import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';

@Component({
  selector: 'app-modal-message-contact-selector',
  templateUrl: './modal-message-contact-selector.component.html'
})
export class ModalMessageContactSelectorComponent extends ExcTranslation implements OnInit {

  @Input() data: any;
  init = true;

  contactList = {
    selectKey: 'kontID',
    showAll: false,
    state: 1,
    data: [] as any[],
    selected: [] as any[],
    selectedObjects: [] as any[],
    searchValue: '',
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter
    } as IExcMetaInfo,
    paging: {pagingPage: 0, pagingEndRow: 0, pagingPageSize: 25, pagingTotalPages: 0, pagingTotalRows: 0, pagingStartRow: 0},
    ready: () => {
      if (!this.contactList.data || this.contactList.data.length === 0) {
        this.contactList.state = 2;
      } else {
        this.contactList.state = 0;
      }
      this.init = false;
    },
    loadData: () => {
      this.excRest.get(this.excRest.computeUrl('MessageContactList', {
        msgtyp: this.data.type,
        oid: this.contactList.showAll ? undefined : this.data.oid,
        fts: this.contactList.searchValue
      }), {MetaInfo: this.contactList.MetaInfo}).subscribe(
        (response: any) => {
          if (response.success) {
            this.contactList.data = response.data;
            this.contactList.paging = response.paging;
          } else {
            this.contactList.data = [] as any[];
            this.contactList.paging.pagingTotalPages = 0;
          }
          this.contactList.ready();
        }
      );
    },
    selectionChanged: ($event: number) => {
    },
    pageChanged: (page: number) => {
      if (this.contactList.MetaInfo.dataPaging !== undefined) {
        this.contactList.MetaInfo.dataPaging.pageNo = page;
      }
      this.contactList.loadData();
    },
    search: (value: string) => {
      this.contactList.searchValue = value;
      this.contactList.pageChanged(1);
    },
    itemSelectionChanged: ($event: number) => {
      if ($event === 0) {
        this.contactList.selectedObjects = [];
      }
      // Remove all not selected elements
      for (let i = 0; i < this.contactList.selectedObjects.length; i++) {
        if (!this.contactList.selected.includes(this.contactList.selectedObjects[i][this.contactList.selectKey])) {
          this.contactList.selectedObjects.splice(i, 1);
        }
      }
      // Add all new selected elements
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.contactList.selected.length; i++) {
        if (this.contactList.selectedObjects.findIndex((e) => {
          return e[this.contactList.selectKey] === this.contactList.selected[i];
        }) === -1) {
          this.contactList.selectedObjects.push(this.contactList.data.find((e) => {
            return e[this.contactList.selectKey] === this.contactList.selected[i];
          }));
        }
      }
    }
  };

  constructor(public modalService: ExgModalService,
              private excRest: ExcRestService) {
    super();
  }

  ngOnInit(): void {
    this.contactList.selectedObjects.length = this.contactList.selected.length = 0;
    this.contactList.selected.push(...this.data.selected);
    this.contactList.selectedObjects.push(...this.data.selectedObjects);
    this.contactList.loadData();
  }

  close(): void {
    this.modalService.close();
  }

  save(): void {
    this.modalService.action({changed: true, selected: this.contactList.selected, selectedObjects: this.contactList.selectedObjects});
  }

}
